import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import { Fold } from "@discovery/prelude/lib/control/lens";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import * as M from "@discovery/prelude/lib/data/maybe";
import { _ContestBannerDesktopImg, _ContestBannerMwebImg } from "./optics";
const ContestHeroView = React.lazy(() => import("../../components/organisms/contest-hero-image"));
const getProps = (data) => {
    const desktopImage = Fold.preview(_ContestBannerDesktopImg, data);
    const mobileImage = Fold.preview(_ContestBannerMwebImg, data);
    return {
        desktopImage,
        mobileImage,
    };
};
const ContestHero = ({ desktopImage, mobileImage }) => {
    const view = M.liftM((desktopImg, mobileImg) => (React.createElement(React.Suspense, { fallback: () => React.createElement(React.Fragment, null) },
        React.createElement(ContestHeroView, { mobileImage: mobileImg, desktopImage: desktopImg }))), desktopImage, mobileImage);
    return React.createElement(RenderMaybe, null, view);
};
export const ComponentMapItem = mkSiteBuilderComponent(getProps, ContestHero);

